import { useCallback, useLayoutEffect, useRef, type FC } from 'react';
import { useDragAndDropContext } from './context';
import { StyledPlaceholderCell, StyledPlaceholderRow } from './styles';
import { type AutomationOrFolder } from 'store/automationsPage/automations.redux';
import { TRow } from '__components/Kizen/Table';

export const DragTRow: FC<{
  columns: { id: string; headCell: JSX.Element; cell: JSX.Element }[];
  data: AutomationOrFolder;
}> = ({ columns, data }) => {
  const { dragging, patching, dragItem, onHoverIn, onHoverOut } =
    useDragAndDropContext();

  const handleHoverIn = useCallback(() => {
    onHoverIn(data);
  }, [data, onHoverIn]);

  const handleHoverOut = useCallback(() => {
    onHoverOut();
  }, [onHoverOut]);

  const rowRef = useRef<HTMLTableRowElement>(null);

  const isDragging = dragging || patching;
  const isActive = dragItem?.id === data.id;

  const isHovered = isActive && !isDragging;

  useLayoutEffect(() => {
    if (rowRef.current) {
      rowRef.current.style.backgroundColor = isHovered
        ? 'var(--color-background-hover)'
        : '';
    }
  }, [isHovered]);

  return isDragging && isActive ? (
    <StyledPlaceholderRow>
      {columns.map((column) => (
        <StyledPlaceholderCell key={column.id}>
          <div />
        </StyledPlaceholderCell>
      ))}
    </StyledPlaceholderRow>
  ) : (
    <TRow
      ref={rowRef}
      columns={columns}
      data={data}
      onMouseEnter={handleHoverIn}
      onMouseLeave={handleHoverOut}
    />
  );
};
